// shared/domain/catalogo.js  (helpers puros para resolver nombres desde catálogos [{ id, nombre }])

/** Nombre de un id en el catálogo; '' si no existe o el id es vacío. */
export const nombrePorId = (catalog, id) => {
  if (id === null || id === undefined) return '';
  const found = (catalog || []).find(item => item.id === id);
  return found ? found.nombre : '';
};

/** Nombres (en el orden de `ids`) de los ids presentes en el catálogo; descarta los desconocidos. */
export const nombresPorIds = (catalog, ids) => (Array.isArray(ids) ? ids : []).map(id => nombrePorId(catalog, id)).filter(Boolean);
